module.exports = __webpack_public_path__ + "static/media/state4.b07a20f9.svg";